import { render, staticRenderFns } from "./TenView.vue?vue&type=template&id=3fbe9c6f"
import script from "./TenView.vue?vue&type=script&lang=js"
export * from "./TenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports